import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { endPoints } from '../api-end-points';
import { Observable, catchError, forkJoin, map, of } from 'rxjs';
import { Registration } from '../Models/RegistrationModel';
import { UserDetails } from '../Models/UserDetailsModel';
import { UserModel } from '../Models/UserModel';
import { UserAddress } from '../Models/UserAddress';
import { Askiitians, Key } from '../Models/AuthModel';
import { GoogleResponseRequestModel } from '../Models/GoogleResponseModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ProcturTokenResponse } from '../Models/ProcturTokenResponse';
import { environment } from 'src/environments/environment';
import { NodeApiCallService } from './node-api-call.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private apiService: ApiCallService,
    private nodeApiService: NodeApiCallService,
    private http: HttpClient
  ) { }

  getEncryptObject(post: Askiitians): Observable<string> {
    return this.apiService.Post(endPoints.ENCRYPT_OBJECT, JSON.stringify(post), {}, 'text');
  }

  getDecryptObject(post: Key): Observable<string> {
    return this.apiService.Post(endPoints.DECRYPT_OBJECT, JSON.stringify(post), {}, 'text');
  }

  checkPhoneNO(mobile: string): Observable<any> {
    const params = { $select: 'Name,Mobile,Id', $filter: `Mobile eq '${mobile}' ` };
    return this.apiService.Get(endPoints.CHECK_PHONE_NO, params);
  }

  verifyLoginOtp(payload: { mobileNumber: string; otp: string }): Observable<any> {
    return this.apiService.Post(endPoints.VERIFY_OTP_LOGIN, JSON.stringify(payload));
  }

  checkUser(mobile: string, email: string): Observable<any> {
    let para = encodeURIComponent(`${mobile}`);
    return this.apiService.Get(`${endPoints.CHECK_USER}?Mobile=${para}&Email=${email}`, null);
  }
  checkEmailId(email: any): Observable<any> {
    const params = { $select: 'Name,Email,Id,Mobile,Password', $filter: `Email eq '${email}' ` };
    return this.apiService.Get(endPoints.CHECK_EMAIL_ID, params);
  }

  findExistingUserByPhoneOrEmail(mobile: string, email: string): Observable<any | null> {
    return forkJoin({
      phone: this.checkPhoneNO(mobile).pipe(catchError(() => of(null))),
      email: this.checkEmailId(email).pipe(catchError(() => of(null))),
    }).pipe(
      map(({ phone, email }) => this.pickFirstUser(phone) ?? this.pickFirstUser(email))
    );
  }
  loginWithEmailId(logindata:any): Observable<any> {
    // const url = `${email}/${password}`;
    return this.apiService.Post(endPoints.lOGIN_USING_EMAIL_ID,JSON.stringify(logindata));
  }
  forgotPassword(emailId: any): Observable<any> {
    const params = { Email: emailId };
    return this.apiService.Get(endPoints.FORGOT_PASSWORD_USING_EMAIL_ID, params)
  }
  create(post: Registration): Observable<any> {
    return this.apiService.Post(endPoints.ADD_USER, JSON.stringify(post));
  }

  edit(PUT: Registration, Id: number): Observable<any> {
    return this.apiService.Put(endPoints.ADD_USER + '/' + Id, JSON.stringify(PUT));
  }

updateProfile(PUT: any, token: string): Observable<any> {
  return this.http.patch<any>(
    `${environment.nodeBaseUrl}/v1/users/profile`,
    PUT,
    {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'x-portal': 'frontend',
        'Content-Type': 'application/json'
      })
    }
  );
}


uploadProfileImage(file: File, userId: number, token: string): Observable<any> {
  const formData = new FormData();

  formData.append('file', file);
  formData.append('userId', userId.toString());
  formData.append('cdnPath', 'user');
  formData.append('subFolder', 'profile');
  return this.http.post<any>(
    `${environment.nodeBaseUrl}/v1/admin/uploads`,
    formData,
    {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'x-portal': 'frontend'
      })
    }
  );
}


  createUserDetails(post: UserDetails): Observable<any> {
    return this.apiService.Post(endPoints.USER_DETAILS, JSON.stringify(post));
  }

  editUserDetails(PUT: UserDetails, Id: number, headers?: Record<string, string>): Observable<any> {
    return this.apiService.Put(endPoints.USER_EDIT_DETAILS + Id, JSON.stringify(PUT), headers);
  }

  getUserFromID(Id: number): Observable<UserModel> {
    return this.apiService.Get(endPoints.GET_USER_BY_ID + Id);
  }

  getUserDetailsById(id: number): Observable<any> {
    return this.nodeApiService.Get(`/users/details/${id}`);
  }

  GetEdmingleClassLink(firstName: string, email: string, lastName: string): Observable<any> {
    const params = { FirstName: `${firstName}`, LastName: `${lastName}`, Email: `${email}` };
    // const url = `${firstName.replace(' ','/')}/${email}`;
    var postData = JSON.stringify(params);
    return this.apiService.Post(endPoints.GET_CLASS_LINK, postData);
  }
  GetProcturToken(userId:number,email: string): Observable<ProcturTokenResponse> {
    const params = {  email: `${email}`,userId:`${userId}`};
    var postData = JSON.stringify(params);
    return this.apiService.Post(endPoints.GET_PROCTUR_TOKEN, postData);
  }
  //get test series url
  GetTestSeriesLink(userID: string): Observable<any> {
    const params = { UserId: `${userID}` };
    return this.apiService.Get(endPoints.GET_TEST_SERIES_LINK + '/' + userID);
  }

  getGradeFromID(Id: number): Observable<any> {
    return this.apiService.Get(endPoints.GET_GRADE_BY_ID + Id);
  }

  getAddessDetails(): Observable<any> {
    return this.apiService.Get(endPoints.GET_ADDRESS_DETAILS);
  }

  getAddessDetailsFromPhone(phone: string): Observable<any> {
    const params = { '$filter': `Phone eq  '${phone}' `, '$select': `Id,Name,Pincode,Address,Landmark,City,State,Country,Phone` };
    return this.apiService.Get(endPoints.GET_ADDRESS_DETAILS_FILTER, params);
  }

  createAddressdetails(post: UserAddress): Observable<any> {
    return this.apiService.Post(endPoints.GET_ADDRESS_DETAILS, JSON.stringify(post));
  }

  EditAddressdetails(PUT: UserAddress, Id: number): Observable<any> {
    return this.apiService.Put(endPoints.GET_ADDRESS_DETAILS + '/' + Id, JSON.stringify(PUT));
  }
  //Google Sign in
  saveGoogleResponse(post: GoogleResponseRequestModel): Observable<any> {
    return this.apiService.Post(endPoints.SAVE_GOOGLE_SIGNIN_RESPONSE, JSON.stringify(post))
  }


  updatePhoneGradeDetails(userData: any): Observable<any> {
    let para = encodeURIComponent(`${userData.mobile}`);
    const params = `UserId=${userData.userDetails.userId}&Mobile=${para}&Grade=${userData.userDetails.grade}`;
    return this.apiService.Post(endPoints.UPADTE_PHONE_AND_GRADE + params, null);
  }

  updateUserDetail(id: number, userdata: any): Observable<any> {
    return this.nodeApiService.Put(`/users/${id}`, JSON.stringify(userdata), { 'Content-Type': 'application/json; charset=utf-8' });
  }

  getQuestionPointsProfile(startIndex: number, endIndex: number, userId: number): Observable<any> {
    return this.apiService.Get(endPoints.TOTAL_QUESTION_DETAILS_BY_USER + userId + `/${startIndex}/${endIndex}`);
  }
  getTotalPostByUser(userId: number): Observable<any> {
    return this.apiService.Get(endPoints.TOTAL_POST_BY_USER + userId);
  }

  getTotalAnswerDetailsByUser(startIndex: number, endIndex: number, userId: number): Observable<any> {
    return this.apiService.Get(endPoints.TOTAL_ANSWER_DETIALS_BY_USER + userId + `/${startIndex}/${endIndex}`);
  }
  getOldPassword(userid: number): Observable<any> {
    const params = { '$filter': `Id eq  '${userid}' `, '$select': `Password` };
    return this.apiService.Get(endPoints.CHECK_EMAIL_ID, params);
  }
  validatePromoCode(promocode: string): Observable<any> {
    //const params = { '$filter': `Id eq  '${userid}' `, '$select': `Password` };
    return this.apiService.Post(endPoints.PURCHASE_SUBSCRIPTION, promocode);
  }
  getSubscriptionPackage(userId:number): Observable<any> {
    //const params = { '$filter': `Id eq  '${userid}' `, '$select': `Password` };
    return this.apiService.Get(endPoints.GET_SUBSCRIPTION_PACKAGE+`?userId=${userId}`);
  }
  changePassword(userId:number,password:string)
  {
    const params = { newpassword: `${password}`};
    // const url = `${firstName.replace(' ','/')}/${email}`;
    var postData = JSON.stringify(params);
    return this.apiService.Put(endPoints.CHANGE_PASSWORD + userId ,postData);
  }

  getCustomizedSubscriptionPackagesByUserId(userId: number): Observable<any[]> {
    return this.apiService.Get(endPoints.GET_CUSTOMIZED_PACKAGE_BY_USERID+`?userId=${userId}`);
  }

  saveLead(leadData: any): Observable<any> {
    return this.nodeApiService.Post(endPoints.AUTH_SAVE_LEAD, leadData);
  }

  private pickFirstUser(response: any): any | null {
    if (!response) {
      return null;
    }

    if (Array.isArray(response)) {
      return response.length > 0 ? response[0] : null;
    }

    if (response?.result?.value) {
      const value = response.result.value;
      return Array.isArray(value) ? value[0] ?? null : value;
    }

    if (response?.data?.result?.value) {
      const value = response.data.result.value;
      return Array.isArray(value) ? value[0] ?? null : value;
    }

    if (response.id || response.Id || response.userId || response.UserId) {
      return response;
    }

    return null;
  }

}
